import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import {
    type ResizablePanelCornerConstantType,
    type ResizablePanelDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    ResizableOrientation
} from "../../type";
import {
    type CornerRadiiType,
    getCornersStyle
} from "../../../../helpers/theme/corner";
import {
    concentric
} from "../../../../helpers/theme/concentric";

export const RESIZABLE_PANEL_SIZE_KEYS: Record<ResizableOrientation, "width" | "height"> = {
    horizontal: "width",
    vertical: "height"
};

export const getPanelCornerStyle = ({
    orientation,
    isFirst,
    isLast,
    radius
}: ResizablePanelCornerConstantType): CornerRadiiType => {
    const corners: CornerRadiiType = {};

    if(orientation === "horizontal") {
        if(isFirst) {
            corners.borderStartStartRadius = radius;

            corners.borderEndStartRadius = radius;
        }

        if(isLast) {
            corners.borderStartEndRadius = radius;

            corners.borderEndEndRadius = radius;
        }

        return corners;
    }

    if(isFirst) {
        corners.borderStartStartRadius = radius;

        corners.borderStartEndRadius = radius;
    }

    if(isLast) {
        corners.borderEndStartRadius = radius;

        corners.borderEndEndRadius = radius;
    }

    return corners;
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        overflow: "hidden"
    },
    stack: {
        flexDirection: "column"
    },
    unmeasured: {
        flexBasis: 0,
        flexGrow: 1
    },
    measured: {
        flexShrink: 0
    }
});

export const useStyles = ({
    collapsedSize,
    isCollapsible,
    shapeConfigs,
    isCollapsed,
    orientation,
    panelCount,
    isFramed,
    radiuses,
    borders,
    colors,
    index,
    mode
}: ResizablePanelDynamicStyleType) => {
    const frameRadius = concentric({
        outer: radiuses.surface,
        role: radiuses.surface,
        inset: borders.line
    });

    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(isFramed && mode === "split") {
        Object.assign(styles.container, getCornersStyle({
            corners: getPanelCornerStyle({
                isLast: index === panelCount - 1,
                isFirst: index === 0,
                radius: frameRadius,
                orientation
            }),
            shapeConfigs
        }));
    }

    if(mode === "stack" && index > 0) {
        Object.assign(styles.container, {
            borderTopColor: colors.content.border.subtle,
            borderTopWidth: borders.separator
        });
    }

    if(mode === "stack" && isCollapsible && isCollapsed) {
        Object.assign(styles.container, {
            height: collapsedSize,
            overflow: "hidden"
        });
    }

    return styles;
};
export default stylesheet;
